import Vue from 'vue'
import Router from 'vue-router'
import AppBase from '@/views/app-base.vue'
import Dashboard from '@/views/dashboard/routes.js'
import Taxonomy from '@/views/taxonomy/routes.js'
import Extract from '@/views/extract/routes.js'
import Culture from '@/views/culture/routes.js'
import User from '@/views/user/routes.js'
import CallBack from '@/views/auth/callback.vue'
import { authService } from '@/auth/auth-service.js'
import settings from '@/settings.js'
Vue.use(Router)

// determine if this is dev mode, automatically set to authorized,
// and manually set defined api key, so that the dev doesnt not need
// to authenticate against a real auth server while developing.
// but they will require a real API key from their api server
console.log('skip login?', settings.SKIP_LOGIN)
if (settings.SKIP_LOGIN === 'true') {
  console.warn('Skipping auth servers, using dev keys')
  // simulates authResult from auth0 flow
  const authResult = {
    accessToken: settings.DEV_API_KEY
  }
  authService.localLogin(authResult)
}

const router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/lims/' : '/',
  routes: [
    {
      path: '/',
      component: AppBase,
      children: [
        Dashboard,
        Culture,
        Extract,
        Taxonomy,
        User
      ]
    },
    {
      path: '/callback',
      name: 'callback',
      component: CallBack
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path === '/callback' && authService.isAuthenticated()) {
    return next('/')
  }
  if (to.path === '/callback' || authService.isAuthenticated()) {
    return next()
  } else {
    authService.renewTokens()
      .then(() => {
        console.log('NEXT', to, from)
        return next()
      })
      .catch((error) => {
        console.log('renewToken error', error)
        authService.login({ target: to.path })
      })
  }
})
export default router
